module.exports = __webpack_public_path__ + "static/media/parking-dark-gray.82a6907b.svg";